const Grad = function(DS) {
    return DS.defineResource({
        name: 'Grad',
        endpoint: '/gradovi'
    });
};

Grad.$inject = ['DS'];

export {Grad};



// WEBPACK FOOTER //
// ./app/models/grad.js